<!--
 * @Description: 结算总价
 * @Date: 2020-12-12 16:02:25
-->
<template>
  <div>
    <div style="color:red">
      【项目支付金额】计算公式为：结算总价=终端结算金额*(1+服务费率）。服务费率是完税成本。项目支付金额为所有结算总价总和
    </div>
    <table-render
      ref="tableRender"
      :config="config"
      height="35vh"
      width="80vw"
      @handleSearch="handleSearch"
    />
    <el-row type="flex" align="middle">
      <el-form :inline="true">
        <el-form-item style="margin-bottom:0" label="核算终端结算总金额：">
          <el-input
            :value="finishSumTaskPrice | moneyFixed"
            disabled
          ></el-input>
        </el-form-item>
        <el-form-item
          style="margin-bottom:0"
          label="项目支付金额（结算总价合计）："
        >
          <el-input :value="totalPrice | moneyFixed" disabled></el-input>
        </el-form-item>
      </el-form>
      <projectData
        :orderId="csoCustomOrderId"
        :csoCustomOrderIds="csoCustomOrderIds"
        :csoCustomOrderSupplierId="csoCustomOrderSupplierId"
        :type="sourceType"
      ></projectData>
      <div style="margin-left:15px;">
        <span>支付通道：{{ payBankText }}</span>
        <span style="margin-left:15px;">服务商付款方式：{{ payTypeText }}</span>
      </div>
    </el-row>

    <!-- <el-alert
      title="【项目支付金额】计算公式为：结算总价=终端结算金额*(1+服务费率）。服务费率是完税成本。项目支付金额为所有结算总价总和"
      type="warning"
      effect="dark"
      :closable="false"
      :show-icon="false"
    ></el-alert> -->
  </div>
</template>

<script>
import tableRender from '@/components/tableRender';
import projectData from '../priceDetail/components/projectData';

import main from './config';
import { payBankFormatter, payTypeFormatter } from '@/common/fields/bank';

export default {
  name: 'priceDetail',
  props: {
    // 当前列表类型 2部分 3已支付 4失效
    sourceType: {
      type: [Number, String],
      default: '',
      required: true
    },
    // 订单ID或者ids
    csoCustomOrderId: {
      type: String,
      default: ''
    },
    // 订单ID或者ids
    csoCustomOrderIds: {
      type: String,
      default: ''
    },
    csoCustomOrderSupplierId: {
      type: String,
      default: '',
      required: true
    },
    taskDt: {
      type: String,
      default: '',
      required: true
    },

    // 获取列表接口
    getList: {
      type: Function,
      default() {
        return () => {};
      },
      required: true
    },
    // 获取总价接口
    getPrice: {
      type: Function,
      default() {
        return () => {};
      },
      required: true
    },
    vm: Object
  },
  data() {
    return {
      projectDataTable: [],
      config: null,
      searchQuery: null, // 指向tableRender中的，监听使用
      finishSumTaskPrice: '', //终端结算总金额合计
      totalPrice: '', // //结算总价合计
      payPassagewayCode: '' // 支付通道
    };
  },
  components: { tableRender, projectData },
  computed: {
    payBankText() {
      return payBankFormatter(this.vm.$parent.fullInfo);
    },
    payTypeText() {
      return payTypeFormatter(this.vm.$parent.fullInfo);
    }
  },
  methods: {
    async handleSearch(v) {
      let { pdata } = await this.getPrice({
        csoCustomOrderId: this.csoCustomOrderId,
        taskDt: this.taskDt,
        csoCustomOrderSupplierId: this.csoCustomOrderSupplierId,
        csoCustomOrderIds: this.csoCustomOrderIds,
        ...v
      });
      Object.assign(this.$data, pdata);
    }
  },
  created() {
    let part = main;
    // 列表接口携带固定参数
    part.childMenu[0].defaultQuery = {
      orderId: this.csoCustomOrderId,
      taskDt: this.taskDt,
      csoCustomOrderSupplierId: this.csoCustomOrderSupplierId,
      csoCustomOrderIds: this.csoCustomOrderIds
    };
    part.childMenu[0].list = this.getList;
    this.config = [part];
  }
};
</script>
